import { ReactComponent as CloseIcon } from 'components/icons/close.svg';
import React from 'react';
import { CloseButton, HeaderWrapper, Separator, Title } from './DialogHeaderStyles';

interface IProps {
  title: string;
  onClose: () => void;
}

const DialogHeader: React.FC<IProps> = (props) => {
  const { title, onClose } = props;

  return (
    <>
      <HeaderWrapper>
        <Title>{title}</Title>
        <CloseButton onClick={onClose} role='none' data-test='game-dialog-close'>
          <CloseIcon />
        </CloseButton>
      </HeaderWrapper>
      <Separator />
    </>
  );
};

export default DialogHeader;
